import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=bcf8b3c8&"
import script from "./Link.vue?vue&type=script&lang=js&"
export * from "./Link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\taiqiu\\back-end\\base\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcf8b3c8')) {
      api.createRecord('bcf8b3c8', component.options)
    } else {
      api.reload('bcf8b3c8', component.options)
    }
    module.hot.accept("./Link.vue?vue&type=template&id=bcf8b3c8&", function () {
      api.rerender('bcf8b3c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Navbar/Link.vue"
export default component.exports